(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neobean-product-trade"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nb-margin')) {
  customElements.define('nb-margin', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('input', () => this.calculate());
    }
    calculate() {
      const sell = Number(this.querySelector('[data-sell]').value);
      const yieldInput = this.querySelector('[data-yield]');
      const units = yieldInput ? Number(yieldInput.value) : Number(this.dataset.pack);
      const profit = this.querySelector('[data-profit]');
      const margin = this.querySelector('[data-margin]');
      if (!(sell > 0 && units > 0) || !Number.isFinite(sell) || !Number.isFinite(units) || (yieldInput && !Number.isInteger(units))) {
        profit.textContent = '—'; margin.textContent = '—'; return;
      }
      const gain = sell - Number(this.dataset.cost) / units;
      profit.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(gain);
      margin.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'percent',maximumFractionDigits:1}).format(gain / sell);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neobean-wholesale-application"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controllers = new Map();
    const styles = `
      :host { --color-text: #123f32; color: #123f32; }
      #app-embed { color: #123f32; background: transparent; }
      [data-testid="app-router"] { max-width: none; width: 100%; }
      form { color: #123f32; }
      h1, h2, h3 { color: #123f32 !important; font-family: Georgia, serif !important; }
      input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="file"]), select, textarea {
        border: 2px solid #123f32 !important; border-radius: 11px !important; color: #123f32 !important; background: #fff !important; font-size: 16px !important; min-height: 50px;
      }
      input[type="checkbox"], input[type="radio"] { accent-color: #123f32; }
      input[type="file"] { max-width: 100%; color: #123f32; }
      button[type="submit"] { border: 2px solid #123f32 !important; border-radius: 999px !important; background: #c9f15a !important; color: #123f32 !important; min-height: 56px; font-weight: 800 !important; box-shadow: 4px 4px 0 #123f32; }
      :is(input, select, textarea, button, a):focus-visible { outline: 3px solid #123f32 !important; outline-offset: 3px; }
      a { color: #123f32; text-underline-offset: 3px; }
    `;
    function initialize(section) {
      if (controllers.has(section)) return;
      const roots = new Set();
      const rootObservers = [];
      const loading = section.querySelector('[data-application-loading]');
      const unavailable = section.querySelector('[data-application-unavailable]');
      let timeout;
      const check = () => {
        let ready = false;
        section.querySelectorAll('shopify-forms-embed').forEach(host => {
          const root = host.shadowRoot;
          if (!root) return;
          if (!roots.has(root)) {
            roots.add(root);
            const style = document.createElement('style');
            style.textContent = styles;
            root.append(style);
            const observer = new MutationObserver(check);
            observer.observe(root, { childList: true, subtree: true });
            rootObservers.push(observer);
          }
          if (root.querySelector('form, [data-testid="app-router"]')) ready = true;
        });
        if (ready) {
          loading.hidden = true;
          unavailable.hidden = true;
          clearTimeout(timeout);
        }
      };
      const observer = new MutationObserver(check);
      observer.observe(section, { childList: true, subtree: true });
      timeout = setTimeout(() => {
        if (!loading.hidden) { loading.hidden = true; unavailable.hidden = false; }
      }, 15000);
      controllers.set(section, () => {
        clearTimeout(timeout);
        observer.disconnect();
        rootObservers.forEach(item => item.disconnect());
        controllers.delete(section);
      });
      check();
    }
    function initializeAll(scope) {
      scope.querySelectorAll('[data-wholesale-application]').forEach(initialize);
    }
    initializeAll(document);
    document.addEventListener('shopify:section:load', event => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-wholesale-application]').forEach(section => controllers.get(section)?.());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
